import React from 'react';
import { useForm } from 'react-hook-form';
import { ModalHeader } from '../../../../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalBody } from '../../../../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../../../../CommonComponents/OPL/Button/Button';
import { Modal } from '../../../../../../CommonComponents/OPL/Modal/Modal';
import { Checkbox } from '../../../../../../CommonComponents/OPL/Checkbox/Checkbox';

const FORM_ID = 'personal-info--delete-partner-form';
export const HEADER_ID = 'personal-info--delete-partner-modal';

interface FormValues {
  deletePartnerData: boolean;
}

interface Props {
  onClose(): void;
  onDeletePartner(keepPartnerData: boolean): void;
}

export const DeletePartnerModal: React.FC<Props> = ({ onClose, onDeletePartner }) => {
  const { register, handleSubmit } = useForm<FormValues>({
    defaultValues: {
      deletePartnerData: false,
    },
  });

  const onSubmit = ({ deletePartnerData }: FormValues) => {
    onDeletePartner(!deletePartnerData);
  };

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={false}
      aria={{ labelledby: HEADER_ID }}
    >
      <ModalHeader as="h2" id={HEADER_ID} variant="warning">
        Are you sure you want to delete this partner?
      </ModalHeader>

      <ModalBody as="form" id={FORM_ID} onSubmit={handleSubmit(onSubmit)}>
        <Checkbox {...register('deletePartnerData')}>
          Delete all associated accounts, assets, or income for this partner.
        </Checkbox>
      </ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button type="submit" form={FORM_ID} variant="error" ml="8">
          Delete Partner
        </Button>
      </ModalFooter>
    </Modal>
  );
};
